import { useEffect, useState } from 'react';

export const useCollapse = (key) => {
  const [open, setOpen] = useState(true);

  const handleCollapse = () => {
    if (!key) {
      setOpen(!open);
      return;
    }
    localStorage.setItem(key, !open);
    setOpen(localStorage.getItem(key) === 'true');
  };

  useEffect(() => {
    if (!key) return;
    if (localStorage.getItem(key))
      setOpen(localStorage.getItem(key) === 'true');
  }, []);

  return [open, handleCollapse];
};
